module.exports = __webpack_public_path__ + "img/tabBg1.09177e97.jpg";